<template>
  <div
    class="mt-4 card move-on-hover cursor-pointer"
    style="min-height: 450px;"
    data-bs-toggle="tooltip"
    data-bs-placement="bottom"
    :title="tooltip"
    :style="{
      opacity: useable ? 1 : 0.5,
    }"
    @click="navigate"
  >
    <div class="card-body d-flex flex-column h-100 position-relative">
      <!-- 상단 텍스트 -->
      <div>
        <p class="mb-0 fs-4 text-dark">{{ text }}</p>
        <p class="mb-0 text-dark">{{ decs }}</p>
      </div>

      <div class="flex-grow-1 position-relative">
        <div class="position-absolute top-50 start-50 translate-middle">
          <i :class="icon" style="font-size: 8rem; color: #2563eb;"></i>
        </div>
      </div>

    </div>
  </div>
</template>



<script>
export default {
  name: "GroupCard",
  props: {
    route: {
      type: String,
      default: "",
    },
    id: {
      type: String,
      default: "",
    },
    text: {
      type: String,
      default: "",
    },
    decs: {
      type: String,
      default: "",
    },
    tooltip: {
      type: String,
      default: "",
    },
    icon: {
      type: String,
      default: "",
    },
    useable: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    localStorage.removeItem("grpId");
  },
  methods: {
    navigate() {
      if (!this.useable) return;
      localStorage.setItem("grpId", this.id);
      this.$router.push(this.route);
    },
  },
};
</script>
